// Datos de Repositorio de PHP
let URL_BACK = 'http://apiback.presenciaonline.com.mx/rpd'
export {
    URL_BACK,
    
}
